'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utils = {
    skEnvironment: function skEnvironment() {
        return window.document.body.classList.contains('sk');
    },
    getCurrencyIntCode: function getCurrencyIntCode() {
        return utils.skEnvironment() ? 'EUR' : 'CZK';
    },
    getQueryStringParam: function getQueryStringParam(paramName) {
        return utils.getParamFromUrl(document.location.href, paramName);
    },
    getParamFromUrl: function getParamFromUrl(url, paramName) {
        var questionMarkIndex = url.indexOf('?');
        if (questionMarkIndex < -1) return '';

        var queryString = url.substring(questionMarkIndex);
        var rex = new RegExp(paramName + '=[^&]+', 'gi');
        var paramAndValue = rex.exec(queryString);
        if (!paramAndValue || paramAndValue.length < 1) return '';

        return unescape(paramAndValue[0].split('=')[1]);
    },
    distinctByParam: function distinctByParam(array, key) {
        return [].concat((0, _toConsumableArray3.default)(new _map2.default((array || []).map(function (item) {
            return [item[key], item];
        })).values()));
    },
    getPhoneCountryCode: function getPhoneCountryCode(collection, deliveryTypeId) {
        if (!collection || !deliveryTypeId) return null;

        var deliveryTypeObject = collection.find(function (dt) {
            return dt.id === deliveryTypeId;
        });
        if (!deliveryTypeObject) return null;

        return deliveryTypeObject.phoneCountryCode;
    },
    formatPossibleFreeDelivery: function formatPossibleFreeDelivery(cart) {
        try {
            var msg = { active: false, text: null };
            var limit = cart.minOrderPriceForFreeDelivery,
                possibleLimit = cart.minOrderPriceForPossibleFreeDelivery,
                totalProductsPrice = cart.totalProductsPrice;

            if (typeof possibleLimit === 'number' && (typeof limit !== 'number' || possibleLimit < limit)) {
                var toReachBonus = possibleLimit - totalProductsPrice.finalPrice;
                if (toReachBonus > 0) {
                    msg.text = (0, _linksoftAlbatros.stringFormat)(Resx.App.BuyMoreForAndYouCanHaveShippingForFreeMessage, (0, _linksoftAlbatros.formatPrice)(possibleLimit, _linksoftAlbatros.PriceType.CartTotalPrice));
                } else {
                    msg.text = Resx.App.YouCanHaveFreeTransportation;
                    msg.active = true;
                }
            }
            return msg;
        } catch (e) {
            console.error('Error in method formatPossibleFreeDelivery.', e);
            return '';
        }
    },

    transformDeliveryItemsToArray: function transformDeliveryItemsToArray(deliveryItemsFromCart) {
        if (!Array.isArray(deliveryItemsFromCart)) return null;

        return deliveryItemsFromCart.map(function (dt) {
            return Array.isArray(dt.collection) && dt.collection.length > 0 ? dt.collection[0] : null;
        }).filter(function (d) {
            return d !== null;
        });
    }
};

exports.default = utils;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/utils.js
// module id = 32
// module chunks = 0 1 2